export const useImageSelection = () => {
  const dateStore = useDataStore()
  const { isHina } = useServiceType()
  const { contentThumbnailUrl, contentManifestUrl, contentInfoUrl } = useContent()
  const { iiifImageUrlFromInfo } = useIIIF()
  function compImageSelection(i: ImageSelection): ImageSelection {
    if (!i) return {}
    let is = clone(i)
    switch (i.imgType) {
      case 'ITEM':
        if (i.itemId) {
          let item = dateStore.item(i.itemId)
          let db = dateStore.database(i.itemId.split('-')[0])
          if (item && db) {
            let provider = dateStore.provider(item.common.provider)
            is.title = !isEmpty(is.title)
              ? is.title
              : {
                  ja: item.common.title,
                  en: item.common.titleEn,
                }
            is.description = !isEmpty(is.description)
              ? is.description
              : {
                  ja: escapeTag(item.common.description),
                  en: escapeTag(item.common.descriptionEn),
                }
            is.contentsRightsType = item.common.contentsRightsType
            is.contentsRights = db.contentsRights
            if (isEmpty(is.source)) {
              if (isHina && db) {
                is.source = db.name
              } else if (provider) {
                is.source = provider.name
              }
            }
            if (!is.sourceUrl) {
              if (item.common.providerUrl) {
                is.sourceUrl = item.common.providerUrl
              } else {
                is.sourceUrl = item.common.linkUrl
              }
            }
            if (is.infoJsonUrl) {
              is.thumbnailUrl = iiifImageUrlFromInfo(is.infoJsonUrl, is, {
                h: 80,
              })
            } else if (!isEmpty(item.common.thumbnailUrl)) {
              is.thumbnailUrl = item.common.thumbnailUrl[0]
            }
            is['data'] = item
            is['internalLink'] = `/item/${item.id}`
          }
        }
        return is
      case 'UPLOAD':
        let c = dateStore.content(i.contentId)
        if (c) {
          is.title = !isEmpty(is.title) ? is.title : c.title
          is.description = !isEmpty(is.description)
            ? is.description
            : c.description
          is.contentsRightsType = c.contentsRightsType
          is.contentsRights = c.contentsRights
          is.source = c.source
          is.sourceUrl = c.sourceUrl
          is.thumbnailUrl =
            c.images?.length > 0
              ? contentThumbnailUrl(c.id, c.images[0].id)
              : null
        }
        return is
      case 'IIIF':
        if (is.infoJsonUrl) {
          is.thumbnailUrl = iiifImageUrlFromInfo(is.infoJsonUrl, is, {
            h: 80,
          })
        }
        return is
      case 'URL':
      default:
        return i
    }
  }

  function toViewerInfo(image: ImageSelection): ViewerInfo {
    if (image) {
      switch (image.imgType) {
        case 'ITEM':
          if (image.manifestUrl) {
            if (!image.manifestUrl) return null
            return {
              type: 'MANIFEST',
              url: image.manifestUrl,
              firstPage: image.infoJsonUrl,
            }
          } else {
            if (!image.url) return null
            return {
              type: 'DIRECT',
              url: image.url,
            }
          }
        case 'UPLOAD':
          if (!image.contentId) return null
          return {
            type: 'MANIFEST',
            url: contentManifestUrl(image.contentId),
            firstPage: contentInfoUrl(image.contentId, image.imageId),
          }
        case 'URL':
          if (!image.url) return null
          return {
            type: 'DIRECT',
            url: image.url,
          }
        case 'IIIF':
          if (!image.manifestUrl) return null
          return {
            type: 'MANIFEST',
            url: image.manifestUrl,
            firstPage: image.infoJsonUrl,
          }
      }
    }
    return null
  }

  function toSinglePageViewerInfo(image: ImageSelection): ViewerInfo {
    if (image) {
      switch (image.imgType) {
        case 'ITEM':
          if (image.infoJsonUrl) {
            return { type: 'INFO', url: image.infoJsonUrl }
          } else if (image.url) {
            return { type: 'DIRECT', url: image.url }
          }
        case 'UPLOAD':
          if (!image.contentId) return null
          return {
            type: 'INFO',
            url: contentInfoUrl(image.contentId, image.imageId),
          }
        case 'URL':
          if (!image.url) return null
          return {
            type: 'DIRECT',
            url: image.url,
          }
        case 'IIIF':
          if (image.infoJsonUrl) return null
          return {
            type: 'DIRECT',
            url: image.infoJsonUrl,
          }
      }
    }
    return null
  }

  const getImageSelectionFromItem = (item: Item, db: Database): ImageSelection => {
    const is: ImageSelection = { imgType: 'ITEM' }
    if (!isEmptyArray(item.common.thumbnailUrl)) {
      is.thumbnailUrl = item.common.thumbnailUrl[0]
      is.url = item.common.thumbnailUrl[0]
    }
    if (item.common.contentsType === 'image' && !isEmptyArray(item.common.contentsUrl)) {
      is.url = item.common.contentsUrl[0]
    }
    is.itemIndex = '0'
    is.title = {
      ja: item.common.title,
      en: item.common.titleEn,
    }
    is.description = {
      ja: item.common.description,
      en: item.common.descriptionEn,
    }
    is.contentsRightsType = item.common.contentsRightsType
    if (db) is.contentsRights = db.contentsRights
    if (item.common.providerUrl) {
      is.sourceUrl = item.common.providerUrl
    } else {
      is.sourceUrl = item.common.linkUrl
    }
    return is
  }

  return {
    compImageSelection,
    toViewerInfo,
    toSinglePageViewerInfo,
    getImageSelectionFromItem
  }

}
